// extracted by mini-css-extract-plugin
module.exports = {"ra-toaster":"ra-toaster_ra-toaster__Jx8kG","open":"ra-toaster_open__6MBHU"};